import { render, staticRenderFns } from "./ZahnarztPraxen.vue?vue&type=template&id=1f3d61b1&"
import script from "./ZahnarztPraxen.vue?vue&type=script&lang=js&"
export * from "./ZahnarztPraxen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports